import StatusItem from "./StatusItem"

import classes from './AICAStatus.module.css'
import { aicaDataOptions } from "../../../../assets/data"



const AICAStatus = () => {

    return <div className={classes.container}>
        <table>
            <tbody>
                {aicaDataOptions && aicaDataOptions.map(item => (
                    <StatusItem key={item.status_title} data={item}/>
                ))}
            </tbody>
        </table>
    </div>
}

export default AICAStatus